<table class="!border-report border w-full">
    @if (auditData.Data.length > 0) {
        <tr class="w-full !bg-report text-left">
            @for (column of auditGridOptions.columns; track column.title;) {
                <th class="py-2.5 px-[7px] text-xs">
                    {{column.title}}
                </th>
            }
        </tr>

        @for(audit of auditData.Data; track audit.AuditLogsID) {
            <tr class="w-full">
                <td class="p-[7px] text-xs">{{audit.AuditLogsID}}</td>
                <td class="p-[7px] text-xs">{{audit.EventType}}</td>
                <td class="p-[7px] text-xs">{{audit.Name}}</td>
                @if(showVersionColumn) {
                    <td class="p-[7px] text-xs">{{audit.Version}}</td>
                }
                <td class="p-[7px] text-xs">{{audit.ExecutedBy}}</td>
                <td class="p-[7px] text-xs">{{dateWithTimezone(audit.CompletedDate)}}</td>
            </tr>

        }
    }@else if(auditData.Data.length === 0){
        <tr class="w-full">
            <td class="p-[7px] text-xs">{{ 'NoSignedStepsFoundYet' | translate }}</td>
        </tr>
    }
</table>
